import { CollapsiblePanel, Divider } from 'components'
import Button from 'components/Button'
import { formatDate } from 'components/layout/topnav/SwitchEventModal'
import { SearchInput } from 'components/lists'
import CreateEvent from 'features/events/CreateEvent'
import { addModal } from 'features/modals/modalSlice'
import { MyEventsFragment, MyOrganizationFragment } from 'generated/graphql'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import routes from 'routes'
import { _ } from 'utils'
import Item from '../components/Item'
import { S } from './Organizations'

interface Props {
    events: MyEventsFragment[]
    organizations: MyOrganizationFragment[]
}

const Events = ({ events, organizations }: Props) => {
    const [search, setSearch] = useState('')
    const dispatch = useDispatch()
    const pastEvents = (events || [])
        .filter((e) => (e.name).toLowerCase().includes(search.toLocaleLowerCase()))
        .filter((e) => (new Date(e.endDate) < new Date()))
        .sort((a, b) => (new Date(a.startDate) < new Date(b.startDate) ? 1 : -1))
    const upcomingEvents = (events || [])
        .filter((e) => (e.name).toLowerCase().includes(search.toLocaleLowerCase()))
        .filter((e) => !(new Date(e.endDate) < new Date()))
        .sort((a, b) => (new Date(a.startDate) < new Date(b.startDate) ? 1 : -1))

    const showCreateEventModal = () => {
        dispatch(
            addModal({
                Component: ({ close }: { close: () => void }) => (
                    <CreateEvent
                        close={close}
                        organizations={organizations}
                    />
                ),
                header: ' ',
            })
        )
    }

    return (
        <S.Wrapper>
            <S.Toolbar>
                <SearchInput
                    onChange={setSearch}
                    placeholder={_('superhome.events.search_placeholder')}
                    debounce={200}
                    md="380px"
                />
                <Button
                    variant="primary"
                    onClick={showCreateEventModal}
                    className="text-white"
                    icon="plusBox"
                >
                    {_('top_navigation.create_event')}
                </Button>
            </S.Toolbar>
            <Divider marginTop={10} />
            <S.Description>
                {_('superhome.events.description')}
            </S.Description>
            <CollapsiblePanel title="upcoming">
                <>
                    {upcomingEvents.map((event) => (
                        <S.Link to={routes.generalSettings.getPath({ eventSlug: event.slug })} key={event.id}>
                            <Item
                                name={event.name}
                                dateInfo={`${formatDate(event.startDate)} to ${formatDate(event.endDate)}`}
                            />
                        </S.Link>
                    ))}
                </>
            </CollapsiblePanel>
            <div className="mt-3" />
            <CollapsiblePanel title="past">
                <>
                    {pastEvents.map((event) => (
                        <S.Link to={routes.generalSettings.getPath({ eventSlug: event.slug })} key={event.id}>
                            <Item
                                name={event.name}
                                dateInfo={`${formatDate(event.startDate)} to ${formatDate(event.endDate)}`}
                            />
                        </S.Link>
                    ))}
                </>
            </CollapsiblePanel>
        </S.Wrapper>
    )
}

export default Events
